import React, { useEffect } from "react";
import { useState } from "react";
import { CustomInput } from "../CustomInput";
import img from "../../assets/Profile/img.png";
import xIcon from "../../assets/Profile/XIcon.svg";
import addIcon from "../../assets/Home/icon-plus.svg";
import axios from "axios";
import Swal from "sweetalert2";
import { set } from "react-hook-form";
const api = process.env.REACT_APP_API_URL;

const Modal = ({ model, onClick, setModels }) => {
  const [coverPreview, setCoverPreview] = useState(null);
  const [blueprintPreview, setBlueprintPreview] = useState(null);
  const [coverFile, setCoverFile] = useState(null);
  const [blueprintFile, setBlueprintFile] = useState(null);
  const [deleteImage, setDeleteImage] = useState(false);
  const [deleteBlueprints, setDeleteBlueprints] = useState(false);

  const updateImages = async (formData) => {
    try {
      const response = await axios.patch(
        `${api}/propertieModel/updateimages/${model.id}`, 
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error al actualizar imágenes:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevenir el comportamiento por defecto
    
    try {
      const formData = new FormData();

      // Solo agregar las imágenes si fueron seleccionadas
      if (coverFile) {
        formData.append('image', coverFile);
      }

      if( deleteImage) {
        formData.append('image', "delete");
      }
      
      if (blueprintFile) {
        formData.append('blueprints', blueprintFile);
      }

      if( deleteBlueprints) {
        formData.append('blueprints', "delete");
      }

      // Solo hacer la llamada si hay archivos para actualizar
      if (formData.has('image') || formData.has('blueprints')) {
        const response = await updateImages(formData);
        if (response.data.success) {
          setModels((prevModels) =>
            prevModels.map((m) =>
              m.id === model.id
                ? { ...m, main_image: response.data.message.data.model_cover, blueprints: response.data.message.data.model_blueprints }
                : m
            )
          );

          console.log("Imágenes actualizadas:", response.data.message.data);
          Swal.fire({
            icon: 'success',
            title: '¡Imágenes actualizadas!',
            text: 'Las imágenes se han actualizado correctamente',
            showConfirmButton: false,
            timer: 1500
          });
          onClick && onClick(response.data);
        }
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Sin cambios',
          text: 'No se seleccionaron archivos para actualizar',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error("Error al enviar:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un error al actualizar las imágenes',
        showConfirmButton: true
      });
    }
  };

  const handleImageChange = (e, setPreview, setFile, setDelete) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
      setDelete(false);
    }
  };


  useEffect(() => {
    // Resetear los estados al abrir el modal
    setCoverPreview(null);
    setBlueprintPreview(null);
    setCoverFile(null);
    setBlueprintFile(null);
    setDeleteImage(false);
    setDeleteBlueprints(false);
  }, [model]);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
      <div className="bg-white rounded-lg p-6 w-[600px] max-w-3xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl">Imágenes del {model.name || "Modelo"}</h2>
          <h1 onClick={() => console.log(model)} className="text-2xl font-bold">Modelo {model.id}</h1>
          <img
            onClick={onClick}
            src={xIcon}
            alt="Cerrar"
            className="cursor-pointer hover:rotate-90 transition-all duration-300"
          />

        </div>{/* Blueprint */}
          <div className="space-y-2">
            <p className="text-sm">Planos del modelo</p>
            <label className="flex flex-col h-48 border-2 border-dashed border-nemu-black rounded-lg cursor-pointer hover:bg-gray-100 transition">
              {(blueprintPreview || model.blueprints) && !deleteBlueprints ? (
                <div className="relative w-full h-full flex items-center justify-center">
                  <img
                    src={blueprintPreview ? blueprintPreview : `${api}/${model.blueprints}`}
                    alt="Vista previa plano"
                    className="max-h-full object-contain"
                  />
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setBlueprintPreview(null);
                      setBlueprintFile(null);
                      setDeleteBlueprints(true);
                    }}
                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 text-xs"
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-full py-3">
                  <img src={img} alt="Subir plano" className="w-8 h-8" />
                  <p className="text-center mt-2">
                    Drop your blueprint here, or
                    <span className="text-nemu-azul cursor-pointer hover:underline"> browse</span>
                  </p>
                  <span className="text-xs text-gray-500">PNG, JPG, PDF hasta 5MB</span>
                </div>
              )}
              <input
                type="file"
                name="blueprint"
                accept="image/*,.pdf"
                className="hidden"
                onChange={(e) => handleImageChange(e, setBlueprintPreview, setBlueprintFile, setDeleteBlueprints)}
              />
            </label>
          </div>

        <div className="space-y-6">
          {/* Imagen de Portada */}
          <div className="space-y-2">
            <p className="text-sm">Imagen secundaria</p>
            <label className="flex flex-col h-48 border-2 border-dashed border-nemu-black rounded-lg cursor-pointer hover:bg-gray-100 transition">
              {(coverPreview || model.main_image) && !deleteImage ? (
                <div className="relative w-full h-full flex items-center justify-center">
                  <img
                    src={coverPreview ? coverPreview : `${api}/${model.main_image}`}
                    alt="Vista previa portada"
                    className="max-h-full object-contain"
                  />
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setCoverPreview(null);
                      setCoverFile(null);
                      setDeleteImage(true);
                    }}
                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 text-xs"
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-full py-3">
                  <img src={img} alt="Subir imagen" className="w-8 h-8" />
                  <p className="text-center mt-2">
                    Drop your image here, or
                    <span className="text-nemu-azul cursor-pointer hover:underline"> browse</span>
                  </p>
                  <span className="text-xs text-gray-500">PNG, JPG hasta 5MB</span>
                </div>
              )}
              <input
                type="file"
                name="cover_page"
                accept="image/*"
                className="hidden"
                onChange={(e) => handleImageChange(e, setCoverPreview, setCoverFile, setDeleteImage)}
              />
            </label>
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClick}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              className="flex items-center gap-2 px-4 py-2 bg-nemu-azul text-white rounded-md hover:bg-blue-600"
            >
              <img src={addIcon} alt="guardar" className="w-4 h-4" />
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;